module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/pc/relation_link_child_right-f6d990a75df32b049bf2a3031526ced7.png";